import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import { useErrorInfoModal } from '@features/modal'
import { useAddressStore } from '@features/shipping-methods'

import {
  CustomerAddress,
  useZonesForGeoPointQuery,
} from '@shared/generated'

export function useZonesFromAddress () {
  const { t: te } = useTranslation('errors')
  const { openErrorInfoModal } = useErrorInfoModal()
  const { selectedAddress, isPickup } = useAddressStore()

  const isCustomer = (addr: unknown): addr is CustomerAddress => {
    return typeof addr === 'object' && addr !== null && 'shop' in addr
  }

  const point = {
    latitude:
      selectedAddress?.customerGeoPoint?.latitude ??
      (isCustomer(selectedAddress)
        ? selectedAddress.shop?.shopGeoPoint?.latitude
        : undefined),
    longitude:
      selectedAddress?.customerGeoPoint?.longitude ??
      (isCustomer(selectedAddress)
        ? selectedAddress.shop?.shopGeoPoint?.longitude
        : undefined),
  }

  const { data, loading, error} = useZonesForGeoPointQuery({
    variables: {
      point
    },
    skip: !point.latitude || !point.longitude,
  })

  const zones = data?.zonesForGeoPoint

  useEffect(() => {
    if (error) {
      console.error('Ошибка при получении зон:', error)
      openErrorInfoModal({
        description: te('fetch_zones'),
      })
    }
  }, [ error ])

  const zone = zones?.[0]

  return {
    zones,
    minOrderCost: zone?.minOrderCost ?? 0,
    deliveryCost: zone?.delivery_cost ?? 0,
    freeSlotDeliveryCostFrom: zone?.freeSlotDeliveryCostFrom ?? 0,
    isPickup,
    loading,
  }
}
